/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_ReconnectInputs */



/**
* | output |
* | --- |
* | "Reconnect" |
*
* @param {Connections_ReconnectInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_reconnect = /** @type {((inputs?: Connections_ReconnectInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_ReconnectInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw koppelen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reconnecter")
	return /** @type {LocalizedString} */ ("Reconnect")
});